import { TableCell, TableRow } from '@mui/material'
import React, { useState } from 'react'
import Status from '../../../../UI/status/Status'
import { getUserName } from '../../../../../helpers/user/UserHelper'
import { Link } from 'react-router-dom'
import SupplyBillPaymentShort from '../../../supplyBills/item/fields/SupplyBillPaymentShort'
import SupplyBillDeliveryShort from '../../../supplyBills/item/fields/SupplyBillDeliveryShort'
import InnerTable from '../../../../UI/table/inner/InnerTable'
import SupplyOrderBillItemsTableShort from './items/SupplyOrderBillItemsTableShort'
import MyTableMoreIco from '../../../../UI/table/MyTableMoreIco'

const SupplyOrderBillItem = ({ supplyOrderBill }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <TableRow>
            <MyTableMoreIco
				open={open}
				setOpen={setOpen}
			/>
            <TableCell align='center'>
                <Link to={`/supply/bills/${supplyOrderBill.id}`}>
                    {supplyOrderBill.id}
                </Link>
                {/* {
                    supplyOrderBill.id
                } */}
            </TableCell>
            <TableCell align='center'>
                {
                    <Status 
                        status={supplyOrderBill.status}
                    />
                }
            </TableCell>
            <TableCell align='center'>
                {
                    getUserName({ user: supplyOrderBill.user })
                }
            </TableCell>
            {/* <TableCell align='center'>
                {
                    supplyOrderBill.supplier ? supplyOrderBill.supplier.name : ''
                }
            </TableCell> */}
            <TableCell align='center'>
                <SupplyBillPaymentShort
                    payments={supplyOrderBill.payments}
                />
            </TableCell>
            <TableCell align='center'>
                <SupplyBillDeliveryShort
                    deliveries={supplyOrderBill.deliveries}
                />
            </TableCell>
            {/* <TableCell align='center'></TableCell> */}
        </TableRow>

        <InnerTable
			open={open}
		>
			<SupplyOrderBillItemsTableShort 
				supplyOrderBillItems={supplyOrderBill.itemsByOrder}
			/>
		</InnerTable>
    </>
  )
}

export default SupplyOrderBillItem